// @flow
import React, { useCallback, useState, useRef } from "react";
import { useUpdateEffect, useToggle } from "hooks";
import Icons from "@hs/icons";
import ClearableInput from "@hs/clearable-input";
import styles from "./Rename.module.css";

type Props = {
    /** controlled input text value */
    name: string,
    /** controller input onChange event */
    onChange: Function,
    /** optional title (tooltip) */
    title?: string,
};

const Rename = ({ name: nameFromProps, onChange, title }: Props) => {
    const inputRef = useRef();
    const [editing, toggleEditing] = useToggle();
    const [name, handleChange] = useState(nameFromProps);
    useUpdateEffect(() => {
        handleChange(nameFromProps);
    }, [nameFromProps]);

    const handleBlur = useCallback(
        (e) => {
            handleChange(nameFromProps);
            toggleEditing();
        },
        [nameFromProps, toggleEditing]
    );

    const handleEnter = useCallback(
        (e) => {
            onChange(name);
            inputRef.current?.blur();
        },
        [name, onChange]
    );
    if (editing) {
        return (
            <ClearableInput
                inputRef={
                    /* istanbul ignore next */ (ref) => (inputRef.current = ref)
                }
                autoFocus={true}
                className={`${styles.input} form-control`}
                type="text"
                value={name}
                onBlur={handleBlur}
                onEnter={handleEnter}
                onChange={handleChange}
            />
        );
    }
    return (
        <div onClick={toggleEditing} className={styles.rename} title={title}>
            {nameFromProps}
            <Icons.Library className={styles.icon} name="pencil" />
        </div>
    );
};

export default Rename;
